// HEADER MEGAMENU JS -- START
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mega-nav__item--has-dropdown').forEach(function (dropdown) {
      const sidebarItems = dropdown.querySelectorAll('.mega-nav__sidebar-item');

      function clearAll() {
        sidebarItems.forEach(i => i.classList.remove('is-active'));
        dropdown.querySelectorAll('.mega-nav__products').forEach(p => p.classList.remove('is-visible'));
      }

      function activateItem(item) {
        clearAll();
        item.classList.add('is-active');
        const handle = item.dataset.collection;
        const panel = dropdown.querySelector('[data-panel="' + handle + '"]');
        if (panel) panel.classList.add('is-visible');
      }

      // ✅ Activate first item immediately on page load
      if (sidebarItems.length > 0) activateItem(sidebarItems[0]);

      dropdown.addEventListener('mouseleave', function () {
        // ✅ Reset back to first item on mouse leave, not empty
        if (sidebarItems.length > 0) activateItem(sidebarItems[0]);
      });

      sidebarItems.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          activateItem(item);
        });
      });
    });
});
// HEADER MEGAMENU JS -- END

// CART PROGRESSBAR JS -- START
setInterval(function () {

    let progressEl = document.querySelector('.cc-cart-progress');
    if (!progressEl) return;

    let goalAmount = progressEl.getAttribute('data-goal-amount');
    let goalBeforeText = progressEl.getAttribute('data-before-amount-text');
    let goalAfterText = progressEl.getAttribute('data-after-amount-text');
    let goalReachText = progressEl.getAttribute('data-goal-reached-text');

    let miniCart = document.querySelector('#t4s-mini_cart');

    if (miniCart && miniCart.getAttribute('aria-hidden') === "false") {

        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {

                let cartData = cart.items;
                let subTotal = 0;
                let totalCart = cartData.length;

                console.log("totalCart", totalCart);

                progressEl.style.display = 'block';

                if (totalCart > 0) {

                    let chkBundle = '';
                    let normalProCounter = 0;

                    cart.items.forEach(function (item) {
                        let str1 = item.title;
                        let str2 = 'Bundle';
                        let str3 = 'Free Returns';

                        if (str1.indexOf(str2) !== -1) {
                            chkBundle = '1';
                        } else {
                            if (str1.indexOf(str3) !== -1) {
                                // do nothing
                            } else {
                                normalProCounter = Number(normalProCounter) + Number(item.quantity);
                            }
                        }
                    });

                    subTotal = cart.total_price;

                    let percentage_reached = (Number(subTotal) / Number(goalAmount)) * 100;

                    if (percentage_reached > 100) {
                        percentage_reached = 100;
                    }

                    let fill = document.querySelector('.cc-cart-progress-fill');
                    if (fill) {
                        fill.style.width = Math.round(percentage_reached) + "%";
                        let span = fill.querySelector('span');
                        if (span) span.innerHTML = Math.round(percentage_reached) + "%";
                    }

                    let progressBar = document.querySelector('.cc-cart-progressbar');
                    if (progressBar) {
                        progressBar.classList.remove("progress-filled");
                        if (percentage_reached === 100) {
                            progressBar.classList.add("progress-filled");
                        }
                    }

                    let cartTotalFull = Number(subTotal) / 100;
                    let tempStr = '';

                    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="common-svg">...</svg>`;

                    if (percentage_reached === 100) {
                        tempStr += goalReachText;

                        svg = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">...</svg>`;
                    } else {
                        if (goalAmount > cartTotalFull) {

                            let goalPendingAmount = (Number(goalAmount) * 100) - subTotal;

                            tempStr += goalBeforeText;
                            tempStr += ' <span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
                            tempStr += Shopify.formatMoney(goalPendingAmount);
                            tempStr += '</span> ';
                            tempStr += goalAfterText;
                        }
                    }

                    if (tempStr !== '') {
                        let messageEl = document.querySelector('.cart__goal__message');
                        if (messageEl) messageEl.innerHTML = tempStr;

                        let svgHtml = document.querySelector('.cc-cart-progress-heading .svg-html');
                        if (svgHtml) {
                            svgHtml.innerHTML = '';
                            svgHtml.innerHTML = svg;
                        }
                    }

                } else {
                    progressEl.style.display = 'none';
                }

            });
    }
}, 100);
// CART PROGRESSBAR JS -- END

// PRODUCT SUBSCRIPTION USPS JS -- START
window.addEventListener('load', function () {
  function replaceContent() {
    const el = document.querySelector('.sls-selling-plan-description-content');
    if (el) {
      el.innerHTML = `
        <ul class="subscribe_usps_list">
          <li><span>FREE shipping on all orders</span></li>
          <li><span>Guaranteed delivery during sell-outs</span></li>
          <li><span>Pause, update frequency or cancel anytime</span></li>
        </ul>
      `;
    }
  }

  const observer = new MutationObserver(function () {
    const el = document.querySelector('.sls-selling-plan-description-content');
    if (el && el.innerText.trim() !== '') {
      replaceContent();
    }
  });

  const parent = document.querySelector('.sls-label-container');
  if (parent) {
    observer.observe(parent, { childList: true, subtree: true });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
// PRODUCT SUBSCRIPTION USPS JS -- END